import { Col, Row } from 'antd';
import React from 'react';
import { isAndroid, isDesktop } from 'react-device-detect';

const ReferDownload: React.FC<{ playstore: string, appstore: string }> = ({ appstore, playstore }) => {

  return (
    <Row gutter={[16, 16]} justify='center' align='middle'>
      {isDesktop ? (
        <><Col>
          <a href={playstore} target={'_blank'} rel="noreferrer">
            <img src='/images/google-play-badge.png' alt='playstore-badge'/>
          </a>
        </Col>
          <Col>
            <a href={appstore} target={'_blank'} rel="noreferrer">
              <img src='/images/appstore-badge.png' alt='appstore-badge'/>
            </a>
          </Col>
        </>) : (
        isAndroid ? (
          <>
            <Col>
              <a href={playstore} target={'_blank'} rel="noreferrer">
                <img src='/images/google-play-badge.png' alt='playstore-badge'/>
              </a>
            </Col>
          </>
        ) : (
          <Col>
            <a href={appstore} target='_blank' rel="noreferrer">
              <img src='/images/appstore-badge.png' alt='appstore-badge'/>
            </a>
          </Col>
        )
      )}
    </Row>
  )
};

export default ReferDownload;